import { render, staticRenderFns } from "./purchaseOrderAction.vue?vue&type=template&id=6bf5163c&scoped=true"
import script from "./purchaseOrderAction.vue?vue&type=script&lang=js"
export * from "./purchaseOrderAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderAction.vue?vue&type=style&index=0&id=6bf5163c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5163c",
  null
  
)

export default component.exports